import React from 'react'
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid, Card } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';

const useStyles = makeStyles(theme => ({

    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '3px 6px',
        width: '100%'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    divTitle: {
        padding: 14,
        borderBottom: '1px solid lightgrey'
    },
    divContent: {
        padding: 12,
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    cardBody: {
        height: '100%'
    }
}));

export default function Alerts() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={classes.titleDiv}>
                <Typography variant="h2">Alerts</Typography>
            </div>

            <Grid container className={classes.gridContainerOuter}>

                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Basic alerts (Lab)
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <Alert severity="error">This is an error alert — check it out!</Alert>
                            <Alert severity="warning">This is a warning alert — check it out!</Alert>
                            <Alert severity="info">This is an info alert — check it out!</Alert>
                            <Alert severity="success">This is a success alert — check it out!</Alert>
                        </div>
                    </Card>
                </Grid>

                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Description alerts
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <Alert severity="error">
                                <AlertTitle>Error</AlertTitle>
                                    This is an error alert — <strong>check it out!</strong>
                            </Alert>
                            <Alert severity="warning">
                                <AlertTitle>Warning</AlertTitle>
                                    This is a warning alert — <strong>check it out!</strong>
                            </Alert>
                            <Alert severity="info">
                                <AlertTitle>Info</AlertTitle>
                                    This is an info alert — <strong>check it out!</strong>
                            </Alert>
                            <Alert severity="success">
                                <AlertTitle>Success</AlertTitle>
                                    This is a success alert — <strong>check it out!</strong>
                            </Alert>
                        </div>
                    </Card>
                </Grid>

            </Grid>


            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} sm={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Outlined alerts
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <Alert variant="outlined" severity="error">
                                This is an error alert — check it out!
                            </Alert>
                            <Alert variant="outlined" severity="warning">
                                This is a warning alert — check it out!
                            </Alert>
                            <Alert variant="outlined" severity="info">
                                This is an info alert — check it out!
                            </Alert>
                            <Alert variant="outlined" severity="success">
                                This is a success alert — check it out!
                            </Alert>
                        </div>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Filled alerts
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <Alert variant="filled" severity="error">
                                This is an error alert — check it out!
                            </Alert>
                            <Alert variant="filled" severity="warning">
                                This is a warning alert — check it out!
                            </Alert>
                            <Alert variant="filled" severity="info">
                                This is an info alert — check it out!
                            </Alert>
                            <Alert variant="filled" severity="success">
                                This is a success alert — check it out!
                            </Alert>
                        </div>
                    </Card>
                </Grid>

            </Grid>

        </div>
    )
}
